module.exports = __webpack_public_path__ + "img/33.7140ec77.png";